import { createListStore } from "./list";
import { DependenciesService } from "@/services/dependencies";

export const useDependenciesStore = createListStore(
  "dependencies",
  DependenciesService
);
